import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1714976694867-bc0e012fab70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx0aGVyYXBpc3QlMjBzZXNzaW9uJTIwd2FybXxlbnwwfHx8fDE3ODg0NzIwMjV8MA&ixlib=rb-4.1.0&q=85";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      navigate("/culture", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Create your account"
      subtitle="You've been invited to complete the GIC&E Contractor Pre-Screening & Competency Assessment."
      image={IMG}>
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div className="space-y-2">
          <Label htmlFor="name">Legal Name</Label>
          <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
            data-testid="register-name" placeholder="First and last name" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email Address</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email" placeholder="you@example.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password" placeholder="Create a password" />
        </div>
        <Button type="submit" disabled={busy} data-testid="register-submit"
          className="w-full bg-[#2C5545] hover:bg-[#224336] rounded-lg py-6 text-base font-semibold transition-transform hover:-translate-y-[1px]">
          {busy ? "Creating…" : "Begin Pre-Screening"}
        </Button>
        <p className="text-center text-sm text-[#515E58]">
          Already have an account?{" "}
          <Link to="/login" className="font-medium text-[#2C5545] hover:underline">Sign in</Link>
        </p>
      </form>
    </AuthLayout>
  );
}
